"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "awards_cont" };
const _hoisted_2 = { class: "awards" };
const _hoisted_3 = { class: "ma-title" };
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "ma-player-cube" };
const _hoisted_6 = ["data-test-player-cube"];
const _hoisted_7 = { key: 0 };
const _hoisted_8 = ["textContent"];
const _hoisted_9 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Award = (0, vue_1.resolveComponent)("Award");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                    onClick: _cache[0] || (_cache[0] = (0, vue_1.withModifiers)((...args) => (_ctx.toggleList && _ctx.toggleList(...args)), ["prevent"])),
                    class: "ma-clickable awards-padding",
                    href: "#",
                    "data-test": "toggle-awards"
                }, [...(_cache[2] || (_cache[2] = [
                        (0, vue_1.createTextVNode)("Awards", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.fundedAwards, (award) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                        key: award.name,
                        title: award.playerName,
                        class: "milestone-award-inline paid",
                        "data-test": "funded-awards"
                    }, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(award.name), 1)
                        ])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.createElementVNode)("span", _hoisted_5, [
                            (0, vue_1.createElementVNode)("i", {
                                class: (0, vue_1.normalizeClass)(["board-cube", `board-cube--${award.color}`]),
                                "data-test-player-cube": award.color
                            }, null, 10, _hoisted_6)
                        ])
                    ], 8, _hoisted_4));
                }), 128)),
                (_ctx.isLearnerModeOn)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_7, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.availableAwardSpots, (spotPrice) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                                key: spotPrice,
                                class: "milestone-award-inline unpaid"
                            }, [
                                (0, vue_1.createElementVNode)("div", {
                                    class: "milestone-award-price",
                                    "data-test": "spot-price",
                                    textContent: (0, vue_1.toDisplayString)(spotPrice)
                                }, null, 8, _hoisted_8)
                            ]));
                        }), 128))
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (0, vue_1.createElementVNode)("span", {
                onClick: _cache[1] || (_cache[1] =
                    (...args) => (_ctx.toggleDescription && _ctx.toggleDescription(...args))),
                title: _ctx.$t('press to show or hide the description'),
                "data-test": "toggle-description"
            }, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", null, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.awards, (award) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_Award, {
                            key: award.name,
                            award: award,
                            showScores: _ctx.showScores,
                            showDescription: _ctx.showDescription
                        }, null, 8, ["award", "showScores", "showDescription"]));
                    }), 128))
                ], 512), [
                    [vue_1.vShow, _ctx.showAwardDetails]
                ])
            ], 8, _hoisted_9)
        ])
    ])), [
        [_directive_trim_whitespace]
    ]);
}
